import { createTheme,CssBaseline,ThemeProvider } from "@mui/material";
import React from "react";
import { QueryClient,QueryClientProvider } from "react-query";
import { BrowserRouter as Router,Route,Routes } from "react-router-dom";
import MainLayout from "./components/MainLayout";
import { DocumentViewerContextProvider } from "./contexts/DocumentViewerContext";
import { ToastContextProvider } from "./contexts/toastContext";
import AdminSettingsPage from "./pages/AdminSettingsPage";
import DocsPage from "./pages/DocsPage";
import ForgotPassword2 from "./pages/ForgotPassword2";
import Home from "./pages/HomePage";
import InviteUserPage from "./pages/InviteUserPage";
import LoginPage from "./pages/LoginPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import SearchResults from "./pages/SearchResults";
import SetPasswordPage from "./pages/SetPasswordPage";


const theme = createTheme({
  palette: {
    background: {
      default: "#73808A",
    },
    primary: {
      main: "#00263A",
      light: "#73808A",
    },
    secondary: {
      main: "#C2A01E",
      light: "#D9C57A",
    },
  },
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
    },
  },
});

const DefaultPage: React.FC = () => {
  return <h1>Page not found</h1>;
};

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ToastContextProvider>
        <ThemeProvider theme={theme}>
          <DocumentViewerContextProvider>
            <CssBaseline></CssBaseline>
            <Router>
              <Routes>
                <Route
                  path={"/forgotpassword"}
                  element={<ForgotPassword2></ForgotPassword2>}
                ></Route>
                <Route path="/resetpassword" element={<ResetPasswordPage />}></Route>
                <Route path="/setpassword" element={<SetPasswordPage />}></Route>
                <Route path="/login" element={<LoginPage />}></Route>
                <Route path="/" element={<MainLayout />}>
                  <Route index element={<Home />}></Route>
                  <Route path="search" element={<SearchResults />}></Route>
                  <Route path="invite" element={<InviteUserPage />}></Route>
                  <Route path="docs/*" element={<DocsPage />}></Route>
                  <Route path="admin-settings" element={<AdminSettingsPage />}></Route>
                </Route>
                <Route path="*" element={<DefaultPage />} />
              </Routes>
            </Router>
          </DocumentViewerContextProvider>
        </ThemeProvider>
      </ToastContextProvider>
    </QueryClientProvider>
  );
}

export default App;
